import type { ReactNode } from 'react';

export const symbol_calendar_view_day: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-283q-24.75 0-42.37-17.63Q120-318.25 120-343v-274q0-24.75 17.63-42.38Q155.25-677 180-677h600q24.75 0 42.38 17.62Q840-641.75 840-617v274q0 24.75-17.62 42.37Q804.75-283 780-283H180Zm0-60h600v-274H180v274Zm-31-437q-12 0-20.5-9t-8.5-21.5q0-12.5 8.63-21 8.62-8.5 21.37-8.5h661q12 0 20.5 9t8.5 21.5q0 12.5-8.62 21-8.63 8.5-21.38 8.5H149Zm0 660q-12 0-20.5-9t-8.5-21.5q0-12.5 8.63-21 8.62-8.5 21.37-8.5h661q12 0 20.5 9t8.5 21.5q0 12.5-8.62 21-8.63 8.5-21.38 8.5H149Zm31-497v274-274Z"
		/>
	</svg>
);
